export default {
  namespaced: true,

  state: () => ({
    // Suporte a duas chaves:
    // cartItemKey: { text, font }
    // designId: { text, font }
    textCustomizations: {},
  }),

  mutations: {
    SET_TEXT_CUSTOMIZATION(state, { key, text, font, maxC }) {
      state.textCustomizations[key] = { text, font, maxC };
    },
    CLEAR_TEXT_CUSTOMIZATION(state, key) {
      delete state.textCustomizations[key];
    },
    RESET_CUSTOMIZATIONS(state) {
      state.textCustomizations = {};
    },
  },

  actions: {
    setTextCustomization({ commit }, payload) {
      commit("SET_TEXT_CUSTOMIZATION", payload);
    },
    clearTextCustomization({ commit }, key) {
      commit("CLEAR_TEXT_CUSTOMIZATION", key);
    },
    resetCustomizations({ commit }) {
      commit("RESET_CUSTOMIZATIONS");
    },
  },

  getters: {
    getText:
      (state) =>
      ({ cartItemKey, designId }) => {
        return (
          (cartItemKey && state.textCustomizations[cartItemKey]) ||
          (designId && state.textCustomizations[designId]) ||
          null
        );
      },
  },
};
